module.exports = __webpack_public_path__ + "img/industria.813b55a8.png";